import {
  drawerWidth,
  transition,
  container
} from "assets/jss/material-dashboard-react.jsx";

const appStyle = theme => ({
  wrapper: {
    position: "relative",
    top: "0",
    height: "100vh",
    backgroundColor: "#F7F6F3", 
    margin: "0 auto",
    maxWidth: "1920px"
  },
  mainPanel: {
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerWidth}px)`
    },
    overflow: "auto",
    position: "relative",
    float: "right",
    ...transition,
    maxHeight: "100%",
    width: "100%",
    overflowScrolling: "touch"
  },
  backgroundPatternImage : {
    width: "25%",
    position: "absolute",
    right: "0",
    top: "0",
    [theme.breakpoints.down('md')]:{
      display: "none"
    }
  },
  content: {
    // marginTop: "70px",
    padding: "0 0",
    minHeight: "calc(100vh - 123px)"
  },
  container,
  map: {
    marginTop: "70px"
  }
});

export default appStyle;
